// extracted by mini-css-extract-plugin
module.exports =  {"header":"Lt3XZ73","title":"eZjIyP7","chevron":"O3_UHBl","expanded":"OvOMU_K"};